/* 
 * 组织机构一览组件 
 * 描述：包括查询（表单）、表格和分页 
 * 创建时间：2017-03-22 
 * 创建人：Shujuan Sun 
 * 修改时间：2017-3-31 
 */
<template>
	<div class="wrapper-content fadeInRight animated tabBox" id="org">
			<div class="ibox-content" v-loading="loadingstatus" element-loading-text="加载中">
				<!--表单查询开始-->
				<div class="form-horizontal" id="search">
					<div class="form-group">
						<label class="col-sm-1 control-label">机构名称</label>
						<div class="col-sm-2">
							<input type="text" class="form-control" v-model.trim="orgName" maxlength="20">
						</div>
						<!--<label class="col-sm-1 control-label">状态</label>
						<div class="col-sm-3">
							<select class="form-control" v-model="orgStatus">
								<option v-for="status in enableList" :value="status.value">{{status.name}}</option>
							</select>
						</div>-->
						<label class="col-sm-1 control-label">联系人</label>
						<div class="col-sm-2">
							<input type="text" class="form-control" v-model.trim="orgPerson" maxlength="10">
						</div>
						<label class="col-sm-1 control-label">联系电话</label>
						<div class="col-sm-2">
							<input type="text" class="form-control" v-model.trim="orgTel" maxlength="11">
						</div>
						<label class="col-sm-1 control-label">机构地址</label>
						<div class="col-sm-2">
							<input type="text" class="form-control" v-model.trim="orgAdd" maxlength="20">
						</div>
					</div>
					<!--<div class="form-group">
						<label class="col-sm-1 control-label">联系电话</label>
						<div class="col-sm-3">
							<input type="text" class="form-control" v-model="orgTel" maxlength="11">
						</div>
						<label class="col-sm-1 control-label">机构地址</label>
						<div class="col-sm-3">
							<input type="text" class="form-control" v-model="orgAdd" maxlength="20">
						</div>
					</div>-->
					<div class="form-group ">
						<div class="col-sm-12 text-right">
							<button v-if="permission.indexOf('organiseList_select') == -1" class="btn btn-primary " @click="startToSearch">查询</button>
							<button v-if="permission.indexOf('organiseList_reset') == -1" class="btn btn-primary " @click="resetToInit">重置</button>
						</div>
					</div>
					<div class="hr-line-dashed"></div>
					<div class="form-group">
						<div class="col-sm-12 text-right">
							<button v-if="permission.indexOf('organiseList_add') == -1" v-show="isAdmin>0"  class="btn btn-primary" @click="openModal('new')">添加新机构</button>
						</div>
					</div>
				</div>
				<!--表单查询结束-->
				<!--表格开始-->
				<div class="table-responsive">
					<div style="overflow:auto;">
						<table class="table table-striped table-bordered table-hover module_table" style="min-width:1600px;">
							<thead>
								<tr role="row">
									<th width="5%">序号</th>
									<th>组织机构名称</th>
									<th @click="reorder('orderNo')" class="hand">顺序号<a class="icon_sort" :class="[orderClicked?'sort_top':'sort_bottom']"></a></th>
									<th @click="reorder('status')" class="hand">状态<a class="icon_sort" :class="[statusClicked?'sort_top':'sort_bottom']"></a></th>
									<th>联系人</th>
									<th>联系电话</th>
									<th>机构管理方</th>
									<th>组织机构地址</th> 
									<th>备注</th>
									<th></th>
								</tr>
							</thead>
							<transition-group name="list-complete" tag="tbody">
								<tr v-for="(orgInfo,index) in orgList" v-bind:key="index + 'organiselist'" class="list-complete-item">
									<td>{{index + 1}}</td>
									<td>{{orgInfo.customerName}}</td>
									<td>{{orgInfo.orderno}}</td>
									<td>{{orgInfo.isenable === 1 ? '启用' : '禁用'}}</td>
									<td>{{orgInfo.linkman}}</td>
									<td>{{orgInfo.telephone}}</td>
									<td>{{orgInfo.customerId==groupId?'' : orgInfo.parentName}}</td>
									<td>{{orgInfo.address}}</td> 
									<td>{{orgInfo.memo}}</td>
									<td class="table-btns text-center">
										<a v-if="permission.indexOf('organiseList_detail') == -1" @click="openModal('detail',index)">详情&nbsp;</a>
										<a v-if="permission.indexOf('organiseList_edit') == -1" v-show="isAdmin==9||(isAdmin>0 &&(orgInfo.levv-orgList[0].levv)<2)"  ref="editBtn" type="button" class="editBtn" @click="openModal('edit',index)">&nbsp;编辑&nbsp;</a>
										<a v-show="isAdmin==9 && (orgInfo.levv-selfOrgInfo.levv)!=0" @click="removeItem(orgInfo.customerId)">&nbsp;删除</a>
										<a v-show="isAdmin==1 && (orgInfo.levv-selfOrgInfo.levv)==1" @click="removeItem(orgInfo.customerId)">&nbsp;删除</a>
										<i v-show="isAdmin==0 " title="不可操作">&nbsp;删除</i>
										<i v-show="isAdmin==1 &&(orgInfo.levv-selfOrgInfo.levv)!=1" title="不可操作">&nbsp;删除</i>
									</td>
								</tr>
							</transition-group>
						</table>
					</div> 
				</div>
				<!--表格结束-->
				<!--分页组件开始-->
				<pagination v-if="orgList.length>0" :pageInfo="pageInfo" v-on:getData="getPageNo">
				</pagination>
				<!--分页组件结束-->
				<!--新建、编辑或详情组件开始-->
				<sub-page 
					:show="toShow" 
					:bigTitleMsg="bigTitle" 
					:scroll="scrollTop" 
					v-on:cancel="handleSubPage">
					<div slot="bodycontent">
						<page-organise-edit 
							v-if="toShow" 
							:orgInfo="orgInfo" 
							:curMode="keywords" 
							:dispatchWeight="authRatio"
							:multiAllowable="isMultiSent"
							:curCustomerName="curCustomerName"
							:curCustomerId="curCustomerId"
                            :serviceFlagSent="serviceFlagSent"
							v-on:goBackPage="handleSubPage"
							v-on:timeToRefresh="initTable" 
							>
						</page-organise-edit>
					</div>
				</sub-page>
				<!--新建、编辑或详情组件结束-->
				<!--页面tab弹框组件开始-->				
				<tab-modal ref="modal1" size="small" title="温馨提示" :scroll='scrollTop' v-on:beforeReveal="adjustPois" v-on:cancel="toCloseModal">
					<p v-text="tipContent"></p>	
					<div slot="footer">
						<button v-if="showWithdraw" class="btn btn-primary" @click="withdrawTabBtn">取消</button>
						<button class="btn btn-primary" @click="confirmTabBtn">确定</button>
					</div>
				</tab-modal>
				<!--页面tab弹框组件结束-->				
			</div>
	</div>
</template>
<script>
	import TabModal from 'components/common/TabModal'
	import SubPage from 'components/common/SubPage'
	import PageOrganiseEdit from 'components/pages/organise/PageOrganiseEdit'
	import Pagination from 'components/common/Pagination'
	import { SEARCH_NOTEXIST,OPERATE_EXCEPTION,DELETE_ENSURE,DELETE_SUCCESS,DELETE_FAILE,GET_FAILE,INFO_EMPTY } from 'static/message'
	import {INFO_STATUS_ALL} from 'static/constant'
	import classlist from 'util/classlist'
	
	export default {
		name: 'PageOrganiseList',
		components: {
			Pagination,
			SubPage,
			PageOrganiseEdit,
			TabModal
		},
		data() {
			return {
				permission:this.$store.state.permission.permission["organiseList"]?this.$store.state.permission.permission["organiseList"]:[],
				loadingstatus:false,
				getTableUrl: '/account/customers', //'../../../static/pageorganise/organise.json',//
				deleteTableUrl: '/account/customers', //"/account/customers/{ID}"
				getDetailUrl: '/account/customers/', //'../../../static/pageorganise/orgdetail.json', //
				isAdmin:0,
				selfOrgInfo:null,
				param: {
					address: '',
					customerName: '',
					isEnable: '',
					linkMan: '',
					page_index: 1,
					sort_asc: '',
					sort_desc: '',
					telephone: ''
				}, //向后台传的参数
				askCount: 0, //记录一共向后台请求了多少回数据，请求一次 +1
				editable: true, //判断编辑按钮是否可用-默认可用
				orgList: [], //表格数据列表
				orgLevel: '', //从后台获取的当前组织机构层级levv
				customerId: '', //当前点击的组织机构id
				itemId:'',//当前点击删除的机构id
				curCustomerName: '',
				curCustomerId:'',
				orderClicked: false, //是否点击了顺序号排序按钮，默认没点击
				orderFlag: 0, //顺序号排序--正序时为0，倒序时为1
				statusClicked: false, //是否点击了状态排序按钮，默认没点击
				statusFlag: 0, //状态排序--正序时为0，倒序时为1
				//关于分页组件--------------
				pageInfo: {}, //分页所需信息
				pageNo: 1, //分页返回的当前页数
				//关于详情组件----------
				toShow: false, //默认不显示subpage页（新建、编辑和详情组件弹框）
				bigTitle: '', //详情弹框标题
				scrollTop: '', //弹框top值
				//以下为查询表单所填信息
				showForm: false,
				orgInfo: {},
				orgName: '',
				orgStatus: 'clear',
				enableList: INFO_STATUS_ALL,
				orgPerson: '',
				orgTel: '',
				orgAdd: '',
				//以下为表格所需的表头属性
				keywords: '', //为区分点击的是新建、编辑还是详细
				carNo: '', //为区分点击的是哪个组织机构（第几条信息）
				//以下为提示弹框组件所需属性			
				tipContent: '', //提示弹框内容
				needRefresh:false,//操作成功后刷新表格数据=>initTable
				showWithdraw:false,//默认不显示取消按钮  
				authRatio:100,
                isMultiSent:2,
                serviceFlagSent:0,
			};
		},
		computed:{
			groupId(){
				return this.$store.state.user.groupid
			}
		},
		watch: {
			toShow: function(val) { //控制提示弹框的top值
				if(val === true) {
					this.adjustPois()
				}else{
				//	this.$refs.modal1.close();
			    	classlist.toggleScroll('open','#org',this);
				}
			}
		},
		created(){
			this.isAdmin = this.$store.state.user.admin;
		},
		beforeMount() {
			this.getTableInfo();
		}, 
		methods: {
			adjustPois(){
				classlist.toggleScroll('close','#org',this);
			},
			getTableInfo() { //请求ajax
				this.loadingstatus = true;
				this.askCount++;
				this.$http.get(process.env.API_ROOT + this.getTableUrl, {params: this.param})
					.then((response) => {
						if(response.body.success) {
							if(response.body.data) {
								const res = response.body.data;								
								const {pageNum,pages,total,isFirstPage,isLastPage} = res;
								this.pageInfo = {
									pageNum: pageNum,
									pages: pages,
									total: total,
									isFirstPage: isFirstPage,
									isLastPage: isLastPage
								}
								this.orgList = res.list;
								if(this.orgList.length>0 && this.selfOrgInfo==null){
									this.selfOrgInfo =this.orgList[0];
								} 
								if(this.orgList.length != 0) {
									if(this.askCount === 1) {
										this.orgLevel = res.list[0].levv;
										this.curCustomerName = res.list[0].customerName
										this.curCustomerId = res.list[0].customerId
									} 
								} else {
									this.$refs.modal1.open();	
									this.tipContent = SEARCH_NOTEXIST
									this.showWithdraw = false;
								}
							}
						} else {						
							this.tipContent = response.body.message
							this.$refs.modal1.open();	
							this.showWithdraw = false;
						}
						this.loadingstatus = false;
					}, (response) => {						
						this.tipContent = response.body.message
						this.$refs.modal1.open();	
						this.showWithdraw = false;
						this.loadingstatus = false;
					})
					.catch((response) => {
						this.tipContent = OPERATE_EXCEPTION
						this.$refs.modal1.open();
						this.showWithdraw = false;
						this.loadingstatus = false;
					})
			},
//			editableCheck() { //判断表格编辑按钮是否可用
//				const orgList = this.orgList;
//				const orgLevel = parseInt(this.orgLevel);
//				const subOrgLevel = orgLevel + 1;
//				this.$nextTick(function() {
//					let oBtn = document.getElementsByClassName('editBtn');
//					let editBtn = Array.from(oBtn)						
//					orgList.map((n, index) => {
//						if(parseInt(n.levv) !== orgLevel && parseInt(n.levv) !== subOrgLevel) {
//							editBtn[index].setAttribute('disabled', 'disabled');
//							editBtn[index].style.color = "gray"
//						} else {
//							editBtn[index].removeAttribute('disabled');
//							editBtn[index].style.color = ""
//						}
//					});
//				})
//			},
			initTable(){
				this.param = {
						address: '',
						customerName: '',
						isEnable: '',
						linkMan: '',
						page_index: 1,
						sort_asc: '',
						sort_desc: '',
						telephone: ''
					}
				this.getTableInfo()
			},
			startToSearch() { //点击开始查询
				//查询的数据传给后台，由后台返回查询结果
				if(this.orgAdd !== '' || this.orgName !== '' || this.orgTel !== '' || this.orgStatus !== 'clear' || this.orgPerson !== '') {
					this.param = {
						address: this.orgAdd || '',
						customerName: this.orgName || '',
						telephone: this.orgTel || '',
						linkMan: this.orgPerson || '',
						page_index: 1,
						sort_desc: '',
						sort_asc: ''
					}
					if(this.orgStatus === '1') {
						this.param.isEnable = '1'
					} else if(this.orgStatus === '0') {
						this.param.isEnable = '0'
					} else {
						this.param.isEnable = ''
					}
					this.getTableInfo()
				} else {
					this.initTable();
				}
			},
			resetToInit() { //点击重置-查询条件为空
				this.$nextTick(function() {
					const oSearch = document.getElementById('search');
					let oInput = oSearch.getElementsByTagName('input');
					for(let i = 0, length = oInput.length; i < length; i++) {
						oInput[i].value = ''
					}
				})
				this.orgStatus = 'clear';
				this.orgAdd = '';
				this.orgName = ''
				this.orgTel = ''
				this.orgPerson = ''
			},
			reorder(key) { //点击表格排序
				this.param.page_index = 1;
				if(key === 'orderNo') { //排顺序号
					this.orderClicked = !this.orderClicked;
					if(this.orderFlag === 0) {
						this.param.sort_desc = 'orderno'
						this.param.sort_asc = ''
						this.orderFlag = 1;
					} else {
						this.param.sort_desc = ''
						this.param.sort_asc = 'orderno'
						this.orderFlag = 0;
					}
				} else { //排状态
					this.statusClicked = !this.statusClicked;
					if(this.statusFlag === 0) {
						this.param.sort_desc = ''
						this.param.sort_asc = 'isenable'
						this.statusFlag = 1;
					} else {
						this.param.sort_desc = 'isenable'
						this.param.sort_asc = ''
						this.statusFlag = 0;
					}
				}
				this.getTableInfo()
			},
			removeItem(itemId) { //点击删除表格信息
				this.itemId = itemId;
				this.$refs.modal1.open();
				this.showWithdraw = true;
				this.tipContent = DELETE_ENSURE.replace('{1}','组织机构')
			},
			getPageNo(pageNo) { //从分页组件获取页码参数
				this.pageNo = pageNo;
				this.param.page_index = pageNo;
				this.getTableInfo();
			},
			openModal(keywords, index) { //点击打开弹框（新建、编辑、详情组件）
				if(keywords === 'new') {
					//	this.curParentName = this.customerName;
					this.bigTitle = '新建组织机构'
					this.showForm = true;
					this.toShow = true; 
					this.authRatio = 100;
				} else {
					const orgArr = this.orgList;
					const {
						parentName,
						customerName,
						parentId,
						customerId
					} = orgArr[index]
					if(keywords === 'detail') {
						this.bigTitle = parentName;
						//查看详情
						this.editInit(customerId);
					} else if(keywords === 'edit') {
						this.bigTitle = customerName
							//编辑初始化
						this.editInit(customerId); 
					} else {
						return false
					}
				}
				this.keywords = keywords;
			},  
			handleSubPage(){
				this.toShow = false;
			},
			closeSubPage() { //关闭弹框（编辑、详情组件）
				this.toShow = false;
			//	this.showForm = false;
			//	const org = document.getElementById('org')
			//	org.style.overflow = 'auto' //显示当前页滚动条
			},
			toCloseModal(){//点击tabModal右上侧X按钮
				this.$refs.modal1.close();
				classlist.toggleScroll('open','#org',this);
			},
			confirmTabBtn(){
				if(this.showWithdraw){
					this.deleateTable(this.itemId);
				}
				this.showWithdraw = false;
				this.closeTabTip();
				if(this.needRefresh){//需要初始化表格数据
					this.initTable()
				}
			},
			withdrawTabBtn(){
				this.closeTabTip();
			},
			closeTabTip() {
				this.$refs.modal1.close();	
				classlist.toggleScroll('open','#org',this);
			},
			deleateTable(itemId) {
				this.$http.delete(process.env.API_ROOT + this.deleteTableUrl + '/' + itemId)
					.then((response) => {
						if(response.body.success) {					
							this.$refs.modal1.open();
							this.showWithDraw = false;
							this.needRefresh = true;//需要初始化表格数据
							this.tipContent = DELETE_SUCCESS
						} else {
							this.showWithDraw = false;
							this.$refs.modal1.open();
							this.tipContent = response.body.message
						}
					}, (response) => {
						this.showWithDraw = false;
						this.$refs.modal1.open();
						this.tipContent = response.body.message
					})
					.catch((response) => {
						this.showWithDraw = false;
						this.$refs.modal1.open();
						this.tipContent = OPERATE_EXCEPTION
					})
			},
			editInit(orgId) {		
				this.$http.get(process.env.API_ROOT + this.getDetailUrl + orgId)
					.then((response) => {
						if(response.body.success) {
							this.pageSize = response.data.pageSize;
							this.listCount = response.data.listCount;
							if(response.body.data) {
								const res = response.body.data;
								if(this.$store.state.user.levv!=3 && this.isAdmin != 0){
									this.getAuthRatio(orgId) 
								}else{
									this.toShow = true;
									this.showForm = true; 
								}
								this.orgInfo = res; 
							} else {
								this.toShow = false;
								this.$refs.modal1.open();
								this.tipContent = INFO_EMPTY.replace('{1}','组织机构')
								this.showWithdraw = false;
							}
						} else {
							this.toShow = false;
							this.$refs.modal1.open();
							this.tipContent = response.body.message
							this.showWithdraw = false;
						}
					}, (response) => {
						this.toShow = false;
						this.$refs.modal1.open();
						this.tipContent = response.body.message
						this.showWithdraw = false;
					})
					.catch((response) => {
						this.toShow = false;
						this.$refs.modal1.open();
						this.tipContent = OPERATE_EXCEPTION
						this.showWithdraw = false;
					})
			},
			getAuthRatio(orgId){
				this.$http.get(process.env.API_INSURANCE_ROOT + '/rescue-api/account/customer/' + orgId)
				.then((res)=>{
					this.toShow = true;
					this.showForm = true; 
					let obj = res.body.data 
					if(!obj) return 
					this.authRatio = obj.dispatchingWeight
                    this.isMultiSent = obj.isMulti
                    this.serviceFlagSent = obj.serviceFlag
				},(res)=>{
					this.toShow = false;
					this.$refs.modal1.open();
					this.tipContent = response.body.message
					this.showWithdraw = false;
					if(!response.body.message){
						this.tipContent = '获取派单权重失败'
					}
				})
				.catch((res)=>{
					this.toShow = false;
					this.$refs.modal1.open();
					this.tipContent = OPERATE_EXCEPTION
					this.showWithdraw = false;
				})
			}
		}
	};
</script>
<style scoped lang="scss"> 	 

table{
	button {
		background-color: rgba(255, 255, 255, 0);
		border: 0;
		color: #009F95;
	}
}
	 
	
	.cus_message {
		display: inline-block;
		background-color: white;
		position: absolute;
		top: 5px;
		color: #FF0000;
		margin-left: 0;
	}
</style>


// WEBPACK FOOTER //
// PageOrganiseList.vue?6d81e1e4